if (!customElements.get('we-hero-slider')) {
  customElements.define(
    'we-hero-slider',
    class WeHeroSlider extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = false;
      }

      connectedCallback() {
        this.swiperEl = this.querySelector('.we-hero__swiper');
        this.paginationEl = this.querySelector('.swiper-pagination');
        this.prevEl = this.querySelector('.swiper-button-prev');
        this.nextEl = this.querySelector('.swiper-button-next');
        this.autoplayDelay = this.dataset.autoplay ? parseInt(this.dataset.autoplay, 10) : 0;

        this.initSlider();

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.onBlockSelect.bind(this));
        }
      }

      disconnectedCallback() {
        if (Shopify.designMode) {
          document.removeEventListener('shopify:block:select', this.onBlockSelect.bind(this));
        }

        if (this.sliderInstance?.slider) {
          this.sliderInstance.slider.destroy(true, true);
        }
      }

      onBlockSelect(event) {
        if (event.detail.sectionId !== this.dataset.sectionId) return;

        const slide = event.target.closest('.swiper-slide');
        if (!slide || !this.sliderInstance?.slider) return;

        const index = Number(slide.dataset.index);
        if (Number.isNaN(index)) return;

        this.sliderInstance.slider.slideToLoop(index);
      }

      initSlider() {
        if (!this.swiperEl) return;

        const slideCount = this.swiperEl.querySelectorAll('.swiper-slide').length;

        this.sliderOptions = {
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 12,
          loop: slideCount > 1,
          grabCursor: true,
          allowTouchMove: true,
          threshold: 5,
          speed: 500,
          watchOverflow: true,
          on: {
            init: this.handleAfterInit.bind(this),
            realIndexChange: this.restartPaginationAnimation.bind(this),
          },
        };

        if (this.paginationEl) {
          this.sliderOptions.pagination = {
            el: this.paginationEl,
            clickable: true,
          };
        }

        if (this.prevEl && this.nextEl) {
          this.sliderOptions.navigation = {
            prevEl: this.prevEl,
            nextEl: this.nextEl,
          };
        }

        if (this.autoplayDelay > 0) {
          this.sliderOptions.autoplay = {
            delay: this.autoplayDelay,
            disableOnInteraction: false,
          };
        }

        this.sliderInstance = new window.FoxTheme.Carousel(this.swiperEl, this.sliderOptions, [
          FoxTheme.Swiper.Autoplay,
        ]);
        this.sliderInstance.init();
      }

      handleAfterInit() {
        if (this.autoplayDelay > 0) {
          this.restartPaginationAnimation();
        }
      }

      restartPaginationAnimation() {
        if (!this.paginationEl || this.autoplayDelay <= 0) return;

        requestAnimationFrame(() => {
          const activeBullet = this.paginationEl.querySelector('.swiper-pagination-bullet-active');

          if (!activeBullet) return;

          activeBullet.classList.remove('swiper-pagination-bullet-active');
          activeBullet.offsetHeight;
          activeBullet.classList.add('swiper-pagination-bullet-active');
        });
      }
    }
  );
}
